module.exports = __webpack_public_path__ + "img/bottom-list3.7b0802fe.png";